import { render } from "./Flipper.vue?vue&type=template&id=632a3086&scoped=true"
import script from "./Flipper.vue?vue&type=script&lang=js"
export * from "./Flipper.vue?vue&type=script&lang=js"

import "./Flipper.vue?vue&type=style&index=0&id=632a3086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632a3086"]])

export default __exports__